import styled from '@emotion/styled'
import * as React from 'react'

import { Networks, useWhitelabel } from 'main/framework'
import { NativeLink, Small, spacing, typography } from 'main/ui'
import { formatPhoneE164, formatPhoneHuman } from 'main/util/phone'

export const HotlineContainer = styled.div`
  padding: ${spacing.minorScale(5)}px;
  text-align: center;

  ${NativeLink} {
    font-size: ${typography.fontSize.hint};
  }
`

export default function HotlineInfoCta() {
  const whitelabel = useWhitelabel()
  const copy = copyToRender(whitelabel.networkAbbr)

  return (
    <HotlineContainer>
      <Small>
        Have questions about your child care search? {copy.cta} at&nbsp;
        <NativeLink href={`tel:${formatPhoneE164(copy.phone)}`}>
          {formatPhoneHuman(copy.phone)}
        </NativeLink>
      </Small>
    </HotlineContainer>
  )
}

function copyToRender(networkAbbr: string | undefined): { cta: string; phone: string } {
  switch (networkAbbr) {
    case Networks.ELI:
      return { cta: 'Call Brighter Futures Indiana', phone: '8002991627' }
    default:
      return { cta: 'Call our Enrollment Specialists', phone: '4154662978' }
  }
}
